<template>
  <div
    class="voice-room-user-info-dialog"
    v-show="visible"
    @click="closeDialog"
  >
    <div class="mask"></div>
    <div
      class="main"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0)"
      @click.stop
    >
      <div class="top-action" v-if="visible">
        <span v-if="myself"></span>
        <el-dropdown
          v-else-if="isHost || isCreate || isAdmin"
          @command="handleClick"
        >
          <img src="../images/voice_room_report_off.png" alt="" />
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="a">甩麥</el-dropdown-item> -->
            <!-- <el-dropdown-item command="transferHost"
              >轉移主持人</el-dropdown-item
            > -->
            <el-dropdown-item command="cancelForbidMsg" v-if="muteTime"
              >取消禁言</el-dropdown-item
            >
            <el-dropdown-item command="forbidMsg" v-else>禁言</el-dropdown-item>
            <el-dropdown-item command="leaveSeat">移出座位</el-dropdown-item>
            <el-dropdown-item command="setAdmin" v-if="isCreate && !isAdminUser"
              >設為管理員</el-dropdown-item
            >
            <el-dropdown-item
              command="cancelAdmin"
              v-if="isCreate && isAdminUser"
              >取消管理員</el-dropdown-item
            >
            <!-- <el-dropdown-item command="e">檢舉</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <span v-else></span>
        <div @click="toPlayerDetail()">
          <span>個人主頁</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="info-box">
        <div class="avatar-box" @click="toPlayerDetail()">
          <img class="avatar" :src="userData.avatarUrl" alt="" />
          <!-- <img
            class="avatar-frame"
            :src="userData.avatarFrame"
            alt=""
            v-if="userData.avatarFrame"
          /> -->
        </div>
        <span>{{ userData.nickname }}</span>
        <span class="uuid">ID:{{ userData.uuid }}</span>
        <div class="user-level-wrap">
          <div
            class="userlevel-tag"
            v-if="userData.userLevel"
            :class="`level-${userData.userLevel}`"
          ></div>
        </div>
      </div>
      <gift-list
        class="gift-lift"
        :list="giftList"
        @click.native="toPlayerDetail()"
      ></gift-list>
      <div class="bottom-action">
        <span @click="toggleFollowUser(userData.followStatus)">{{
          userData.followStatus === 'Unfollow' ? '追蹤' : '已追蹤'
        }}</span>
        <span @click="openChat()">私信</span>
        <span class="send-gift" @click="handleSendGift()">送禮</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getGiftWall as getGiftWallRequest,
  forbidMsg as forbidMsgRequest,
  getMutedAccounts as getMutedAccountsRequest,
  setMyVoiceRoomAdmin,
  cancelMyVoiceRoomAdmin,
  agreeApplyMic
} from '@/api/voice-room';
import GiftList from './gift-list.vue';
import { mapGetters } from 'vuex';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import SeatProvider from '@/components/VoiceRoom/seatProvider';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import { followUser, getFollowInfo as getFollowInfoRequest } from '@/api';

export default {
  name: 'UserInfoDialog',
  components: {
    GiftList
  },
  props: {},
  data() {
    return {
      visible: false,
      userData: {},
      loading: false,
      giftList: [],
      muteTime: '',
      followUserLoading: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo']),
    // 是否主持人
    isHost() {
      return SeatProvider.isHost;
    },
    // 是否房主
    isCreate() {
      return CurrentUserProvider.isCreate;
    },
    // 是否管理员
    isAdmin() {
      return CurrentUserProvider.isAdmin;
    },
    // 被查看的用户是否已设置为管理员
    isAdminUser() {
      return VoiceRoomProvider.adminList.some(item => {
        return item.uuid === this.userData.uuid;
      });
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    myself() {
      return this.uuid === this.userData.uuid;
    },
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    }
  },
  methods: {
    async show(userId) {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const { data } = await getFollowInfoRequest({ uuid: userId });
        this.userData = data;
        await this.getGiftWall(userId);
        await this.getMutedAccounts();
        await VoiceRoomProvider.getAdminList();

        this.visible = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // async getFollowInfo() {
    //   const { data } = await getFollowInfoRequest({ uuid: this.userData.uuid });
    //   this.
    // },
    closeDialog() {
      this.visible = false;
      this.loading = false;
      this.giftList = [];
      this.userData = {};
    },
    async getGiftWall(userId) {
      const { data } = await getGiftWallRequest({ playerUserUuid: userId });
      if (data && data.giftList) {
        this.giftList = data.giftList || [];
      }
    },
    async handleClick(event) {
      if (event === 'transferHost') {
        if (SeatProvider.list[0] && SeatProvider.list[0].userUuid) {
          await SeatProvider.forceLeaveMic(0, SeatProvider.list[0].userUuid);
        }
        let params = {};
        params['roomUid'] = this.roomId;
        params['action'] = 'AgreeAskingMic';
        params['targetUuid'] = this.userData.uuid;
        params['seatIndex'] = 0;
        await agreeApplyMic(params);
        this.closeDialog();
      }
      if (event === 'leaveSeat') {
        const index = SeatProvider.getSeatIndex(this.userData.uuid);
        await SeatProvider.forceLeaveMic(index, this.userData.uuid);
        this.closeDialog();
      }
      if (event === 'forbidMsg') {
        try {
          await forbidMsgRequest({
            accounts: [this.userData.uuid],
            muteTime: 429496729,
            roomUid: this.roomId
          });
          this.$message.success('禁言成功');
        } catch (error) {
          this.$message.error('禁言失败');
        }
        this.closeDialog();
      }
      if (event === 'cancelForbidMsg') {
        try {
          await forbidMsgRequest({
            accounts: [this.userData.uuid],
            muteTime: 0,
            roomUid: this.roomId
          });
          this.$message.success('取消禁言成功');
        } catch (error) {
          this.$message.error('取消禁言失败');
        }
        this.closeDialog();
      }
      if (event === 'setAdmin') {
        try {
          await setMyVoiceRoomAdmin({
            uuid: this.userData.uuid,
            roomUid: this.roomId
          });
          this.$message.success('设置管理员成功');
          CurrentUserProvider.setAdmin(true);
        } catch (error) {
          this.$message.error('设置管理员失败');
        }
        this.closeDialog();
      }
      if (event === 'cancelAdmin') {
        try {
          await cancelMyVoiceRoomAdmin({
            uuid: this.userData.uuid,
            roomUid: this.roomId
          });
          this.$message.success('取消管理员成功');
          CurrentUserProvider.setAdmin(false);
        } catch (error) {
          this.$message.error('取消管理员失败');
        }
        this.closeDialog();
      }
    },
    toPlayerDetail() {
      window.open(`/player-detail/${this.userData.uuid}`);
    },
    //获取禁言列表
    async getMutedAccounts() {
      const { data } = await getMutedAccountsRequest({
        account: this.userData.uuid,
        roomUid: this.roomId
      });
      if (data && data.length) {
        this.muteTime = data[0].muteTime;
      } else {
        this.muteTime = 0;
      }
      return true;
    },

    //送礼
    handleSendGift() {
      this.$emit('sendGift', this.userData);
      this.closeDialog();
    },

    //关注
    async toggleFollowUser(followOptType) {
      if (this.followUserLoading) {
        return;
      }
      try {
        this.followUserLoading = true;
        const newFollowOptType =
          followOptType === 'Unfollow' ? 'Follow' : 'Unfollow';
        await followUser({
          followOptType: newFollowOptType,
          uuid: this.userData.uuid
        });
        this.userData.followStatus = newFollowOptType;
        this.$message.success(
          newFollowOptType === 'Follow' ? '追蹤成功' : '取消追蹤成功'
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.followUserLoading = false;
      }
    },

    openChat() {
      if (this.userInfo) {
        this.$util.openChatWindow(this.uuid, this.userData.uuid);
      } else {
        this.$util.Login();
      }
    }
  },
  created() {
    // this.show('1000913');
  }
};
</script>
<style lang="scss" scoped>
.voice-room-user-info-dialog {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 14px;
  width: 100%;
  height: 100%;
  color: white;
  border-radius: 20px;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  z-index: 10;
}
.main {
  width: 360px;
  height: 520px;
  background-color: #101024;
  border-radius: 20px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
  .top-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 14px;
    img {
      width: 20px;
    }
  }

  .info-box {
    position: absolute;
    left: 50%;
    top: -38px;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.8;
    .avatar {
      width: 70px;
      height: 70px;
      object-fit: cover;
      border-radius: 50%;
      margin-bottom: 10px;
    }
    .uuid {
      margin-bottom: 2px;
      font-size: 12px;
    }
  }
  .gift-lift {
    position: absolute;
    bottom: 140px;
  }
  .bottom-action {
    color: #ffdf6b;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    bottom: 40px;
    left: 0;
    width: 100%;
    span {
      padding: 9px 28px;
      cursor: pointer;
    }
    .send-gift {
      color: white;
      border-radius: 20px;
      background: #f72586;
    }
  }
}
</style>
